import clsx from "clsx";
import {Box, Card, Grid, makeStyles, Typography,} from "@material-ui/core";
import React from "react";
import {empty} from "../../../../../state/utils/Common";
import Loading from "../../../../atoms/Loading";
import {managerCommonStyles} from "../../../../theme/manager/styles/common";
import {FixedSizeList} from "react-window";
import {UsersListRow} from "./UserListRow";
import AutoSizer from "react-virtualized-auto-sizer";
import globalTheme from "../../../../theme/globalTheme";
import Auth0Utils from "../../../../../state/utils/Auth0Utils";
import {useAuth0} from "@auth0/auth0-react";

/**
 * コンポーネントスタイル
 *
 * @type {(props?: any) => ClassNameMap<"paper"|"root">}
 */
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        border: "1px #CCCCCC solid",
        boxShadow: "none"
    },
    paper: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));
/**
 * 管理者側のユーザー一覧
 *
 * @param {makeStyles} className - コンポーネントのスタイル
 * @param {Object} users - ロードされたユーザー
 * @param {number|string} loginUserID - ログインしているユーザーID
 * @param {*} managerViewDeleteToggle - 削除確認モーダルビューの動作をトグル
 * @param {*} managerViewRegisterToggle - トグル表示 レジスタ/エディットモーダル
 * @param {managerLoadingUserList} managerLoading - "一覧が読み込まれていますか？"状態
 * @param {*} t - 翻訳オブジェクト
 * @returns {JSX.Element}
 * @constructor
 */
const UsersList = ({
                       className,
                       users,
                       loginUserID,
                       managerViewDeleteToggle,
                       managerViewRegisterToggle,
                       managerUnlockAuth0User,
                       managerResendAuth0VerifyMail,
                       managerLoading,
                       userRoles,
                       t
                   }) => {
    const classes = useStyles();

    /**
     * ユーザーリストの編集・削除のイベント処理
     */
    function handleEditClick(id) {
        managerViewRegisterToggle(id)
    }

    function handleDeleteClick(id) {
        managerViewDeleteToggle(id)
    }

    // auth0 アクショントークンを取得
    const {getAccessTokenSilently} = useAuth0();

    const common = managerCommonStyles();
    const _globalTheme = globalTheme._default();
    return (
        <Card
            className={clsx(classes.root, className)}
        >
            <Box p={2}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography
                            color="textPrimary"
                            variant="body1"
                            style={{fontWeight: 900}}
                        >
                            {t('users.list')}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography
                            color="textPrimary"
                            variant="body1"
                            style={{'textAlign': 'right'}}
                        >
                            {t('general.list_amount', {amount: !empty(users) ? users.length : 0})}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
                <Grid container className={common.tableHeader}>
                    <Grid item xs={3}>
                        <Typography style={{fontWeight: "bold"}}>
                            {t('users.list_headers.user_name')}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography style={{fontWeight: "bold"}}>
                            {t('users.list_headers.mail_address')}
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography style={{fontWeight: "bold"}}>
                            {t('users.list_headers.roles')}
                        </Typography>
                    </Grid>
                    <Grid item xs={1} style={{textAlign: "center"}}>
                        <Typography style={{fontWeight: "bold"}}>
                            {t('users.list_headers.edit')}
                        </Typography>
                    </Grid>
                    <Grid item xs={1} style={{textAlign: "center"}}>
                        <Typography style={{fontWeight: "bold"}}>
                            {t('users.list_headers.password_lock')}
                        </Typography>
                    </Grid>
                    <Grid item xs={1} style={{textAlign: "center"}}>
                        <Typography style={{fontWeight: "bold"}}>
                            {t('users.list_headers.authentication_mail')}
                        </Typography>
                    </Grid>
                    <Grid item xs={1} style={{textAlign: "center"}}>
                        <Typography style={{fontWeight: "bold"}}>
                            {t('users.list_headers.delete')}
                        </Typography>
                    </Grid>
                </Grid>
                {managerLoading === true ?
                    <Box className={_globalTheme.list} display="flex" alignItems="center" data-testid={"loading"}>
                    <Grid container
                          direction="row"
                          justify="center"
                          alignItems="center"
                    >
                        <Grid item xs={12}>
                            <Loading/>
                        </Grid>
                    </Grid>
                    </Box>
                        : !empty(users) &&
                    <Box className={_globalTheme.list} data-testid={"has-users"}>
                    <AutoSizer>
                        {({height, width}) => (
                            <FixedSizeList
                                width={width}
                                height={height}
                                itemCount={users.length}
                                itemSize={45}
                                itemData={{
                                    users: users,
                                    loginUserID: loginUserID,
                                    userRoles: userRoles,
                                    t: t,
                                    handleEditClick: (id) => handleEditClick(id),
                                    handleDeleteClick: (id) => handleDeleteClick(id),
                                    unlockAuth0User: (async (userId) => {
                                        const access_token = await Auth0Utils.checkAndUpdateAccessToken(
                                            () => {
                                                return getAccessTokenSilently();
                                            },
                                        );
                                        managerUnlockAuth0User(access_token, userId)
                                    }),
                                    resendAuth0VerifyMail: (async (userId) => {
                                        const access_token = await Auth0Utils.checkAndUpdateAccessToken(
                                            () => {
                                                return getAccessTokenSilently();
                                            },
                                        );
                                        managerResendAuth0VerifyMail(access_token, userId)
                                    })
                                }}
                            >
                                {UsersListRow}
                            </FixedSizeList>
                        )}
                    </AutoSizer>
                    </Box>
                }
        </Card>
    );
};

export default UsersList;
